// extracted by mini-css-extract-plugin
export var contained = "Resources-module--contained--5fd4b";
export var content = "Resources-module--content--32b2c";
export var image = "Resources-module--image--275df";
export var media = "Resources-module--media--8fe10";
export var resource = "Resources-module--resource--06b10";
export var resources = "Resources-module--resources--979db";
export var title = "Resources-module--title--7a19b";
export var video = "Resources-module--video--2f200";